import React, { useState } from 'react'
import LassoModal from '../../../../components/LassoModal';
import { Box, Button, IconButton, Stack, Typography } from '@mui/material';
import { LassoTab, LassoTabs } from '../../../../components/LassoTabs';
import {
    useGetSavedAdvancedQueriesQuery,
    useGetSharedQueriesQuery,
} from '../../../../api/dataWranglerApiSlice';
import { useDispatch, useSelector } from 'react-redux';
import {
    setAdvancedFields,
    setQueryWizard,
    setSelectedQueryTool
} from '../../dataWranglerSlice';
import { useUserInfoQuery } from '../../../../api/userApiSlice';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import QueriesList from "../QueryWizard/QueriesList";
import { selectSelectedDatabase } from '../../../common/databaseSlice';

const ADWLoadQuery = ({ open, setOpen }: any) => {
    const { data: userData } = useUserInfoQuery({});
    const [selectedQueryType, setSelectedQueryType] = useState("own");
    const [selectedQueryId, setSelectedQueryId] = useState("-1");
    const dispatch = useDispatch();
    const selectedDatabase = useSelector(selectSelectedDatabase);
    const isGuestUser = userData?.id === -1
    const { data: queries } = useGetSavedAdvancedQueriesQuery({ database: selectedDatabase }, { skip: isGuestUser });
    const { data: sharedQueries } = useGetSharedQueriesQuery({ database: selectedDatabase }, { skip: isGuestUser });

    const queryTypes: any = {
        core: [],
        own: [],
        shared: sharedQueries,
        workingGroup: {}
    };

    queries?.forEach((query: any) => {
        if (query.type === 'core') {
            queryTypes.core.push(query);
            return;
        }

        if (userData.username === query.user) {
            queryTypes.own.push(query);
        }
    })

    const handleTabChange = (event: React.SyntheticEvent, newTab: string) => {
        setSelectedQueryType(newTab);
    }

    const onSubmit = () => {
        if (queries) {
            const query = queries.find((query) => query.id === selectedQueryId)
                ?? sharedQueries.find((query: any) => query.id === selectedQueryId);
            if (query.builder === "wizard") {
                dispatch(setSelectedQueryTool("queryWizard"));
                dispatch(setQueryWizard(query.query));
            } else {
                dispatch(setSelectedQueryTool("dictionary"));
                dispatch(setAdvancedFields(query.query));
            }
            setOpen(false);
        }
    }

    //Disable Load Button: If query is advanced and role includes "DUCREQUIRED"
    const selectedQueryData = queries?.find((q: any) => q.id === selectedQueryId) ||
        sharedQueries?.find((q: any) => q.id === selectedQueryId);
    const isAdvancedQuery = selectedQueryData?.builder !== "wizard";
    const isDUCRequired = userData?.roles?.includes("DUCREQUIRED") && !userData?.roles?.includes("ADMIN");
    const isButtonDisabled = isAdvancedQuery && isDUCRequired;

    return (
        <LassoModal open={open} onClose={() => setOpen(false)}>
            <Stack>
                <Stack flexDirection="row" justifyContent="space-between">
                    <Typography fontSize="24px" fontWeight="600">Select query to load</Typography>
                    <IconButton onClick={() => setOpen(false)}>
                        <HighlightOffIcon/>
                    </IconButton>
                </Stack>
                <LassoTabs value={selectedQueryType} onChange={handleTabChange}>
                    <LassoTab label="My Queries" value="own"/>
                    <LassoTab label="Queries shared with me" value="shared"/>
                </LassoTabs>
                <Box width="550px" minHeight="550px">
                    <QueriesList
                        queries={queryTypes[selectedQueryType] ?? []}
                        selectedQuery={selectedQueryId}
                        setSelectedQuery={setSelectedQueryId}
                    />
                </Box>

                <Button variant="primary" onClick={onSubmit} sx={{ alignSelf: "center", mt: 3 }}
                    disabled={isButtonDisabled}>Load Query</Button>
            </Stack>

        </LassoModal>
    )
}

export default ADWLoadQuery